/* one% Reviews: moving wall (Reviews Section.dc.html, layout "B · Moving wall").
   - Header, stars and marketplace pills enter when 20% of the section is in view.
   - The wall drifts via CSS; it pauses on hover (CSS) and while off-screen (class set here).
   - Reduced motion: everything shows at once and the wall stays still (CSS). */
(function () {
  if (customElements.get('op-reviews')) return;

  class OpReviews extends HTMLElement {
    connectedCallback() {
      var self = this;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        this.classList.add('is-in');
        return;
      }
      this.classList.add('is-offscreen');

      this.enterIo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          self.classList.add('is-in');
          self.enterIo.disconnect();
        }
      }, { threshold: 0.2 });
      this.enterIo.observe(this);

      var wall = this.querySelector('[data-op-wall]');
      if (wall) {
        this.viewIo = new IntersectionObserver(function (entries) {
          self.classList.toggle('is-offscreen', !entries[0].isIntersecting);
        });
        this.viewIo.observe(wall);
      }
    }

    disconnectedCallback() {
      this.enterIo && this.enterIo.disconnect();
      this.viewIo && this.viewIo.disconnect();
    }
  }

  customElements.define('op-reviews', OpReviews);
})();
